import React, { FC } from 'react'
import { QuantiteUcDisplayable, Sortie, SortieCommentaireForm } from '../services/sortie.types'
import { Grid, withStyles } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import { getStyles } from 'isotope-client'
import SortieDialogBody from './SortieDialogBody'
import { compose } from 'redux'
import { ConfigProps } from 'redux-form/lib/reduxForm'
import { connect } from 'react-redux'
import { Field, FormErrors, InjectedFormProps, reduxForm } from 'redux-form'
import { FORM_FIELDS, UPDATE_COMMENTAIRE_SORTIE_FORM } from '../services/sortie.consts'
import Input from '../../../../components/form/Input'

const styles = () => getStyles({
	container: {
		margin: '12px 24px',
		maxWidth: 400
	},
	form: {
		margin: '24px 36px 0px 26px',
		width: '100%'
	},
})

type UpdateCommentaireSortieDialogProps = {
	sortie: Sortie
	quantiteUcDisplayable: QuantiteUcDisplayable
	classes: ClassNameMap
}

const validate = (values: SortieCommentaireForm): FormErrors<SortieCommentaireForm> => {
	const errors: FormErrors<SortieCommentaireForm> = {}

	// Max length commentaire
	if ((values[FORM_FIELDS.COMMENTAIRE as keyof SortieCommentaireForm] ?? '').toString().length > 500) {
		errors[FORM_FIELDS.COMMENTAIRE as keyof SortieCommentaireForm] = <FormattedMessage id="sorties.form.commentaireSize" />
	}

	return errors
}

/**
 * Dialog de modification du commentaire d'une sortie
 */
const UpdateCommentaireSortieDialog: FC<UpdateCommentaireSortieDialogProps & InjectedFormProps<SortieCommentaireForm>> = (
	{
		sortie,
		quantiteUcDisplayable,
		handleSubmit,
		classes
	}
) => {
	return <Grid container className={classes.container}>
		<SortieDialogBody sortie={sortie} quantiteUcDisplayable={quantiteUcDisplayable} />
		<form onSubmit={handleSubmit} className={classes.form}>
			<Field
				name={FORM_FIELDS.COMMENTAIRE}
				component={Input}
				label={<FormattedMessage id="sorties.labels.commentaire" />}
				style={{ width: '100%' }}
				reverseBackground
			/>
		</form>
	</Grid>
}

type ConnectedProps = {
	sortie: Sortie
	quantiteUcDisplayable: QuantiteUcDisplayable
}

const mapStateToProps = (_: any, {
	sortie
}: ConnectedProps) => {
	return ({
		initialValues: {
			[FORM_FIELDS.COMMENTAIRE]: sortie.commentaire
		}
	})
}

export default compose<FC<ConfigProps<SortieCommentaireForm> & ConnectedProps>>(
	connect(mapStateToProps),
	reduxForm({
		form: UPDATE_COMMENTAIRE_SORTIE_FORM,
		enableReinitialize: true,
		validate
	}),
	withStyles(styles)
)(UpdateCommentaireSortieDialog)